import axios from 'axios'
import type {
  FetchHospitalLocationsParams,
  HospitalLocation,
  HospitalLocationWritePayload,
  PaginatedResponse,
} from '@/modules/settings/types/hospitalStructure.types'
import { BASE_URL } from '@/environment/environment'

const API_URL = `${BASE_URL}/api/hospital/hospital`

function normalizePage(
  data: PaginatedResponse<HospitalLocation> | HospitalLocation[],
): PaginatedResponse<HospitalLocation> {
  if (Array.isArray(data)) {
    return {
      count: data.length,
      next: null,
      previous: null,
      results: data,
    }
  }
  return {
    count: data.count,
    next: data.next ?? null,
    previous: data.previous ?? null,
    results: data.results || [],
  }
}

export const hospitalStructureApi = {
  /** Пагинированный список корней дерева (cursor + page_size). */
  async listPage(params?: FetchHospitalLocationsParams): Promise<PaginatedResponse<HospitalLocation>> {
    const { data } = await axios.get<PaginatedResponse<HospitalLocation> | HospitalLocation[]>(`${API_URL}/`, {
      params,
    })
    return normalizePage(data)
  },

  async list(params?: FetchHospitalLocationsParams): Promise<HospitalLocation[]> {
    const page = await this.listPage(params)
    return page.results
  },

  async get(id: string): Promise<HospitalLocation> {
    const { data } = await axios.get<HospitalLocation>(`${API_URL}/${id}/`)
    return data
  },

  async create(payload: HospitalLocationWritePayload): Promise<HospitalLocation> {
    const { data } = await axios.post<HospitalLocation>(`${API_URL}/`, payload)
    return data
  },

  async update(id: string, payload: Partial<HospitalLocationWritePayload>): Promise<HospitalLocation> {
    const { data } = await axios.patch<HospitalLocation>(`${API_URL}/${id}/`, payload)
    return data
  },

  async remove(id: string): Promise<void> {
    await axios.delete(`${API_URL}/${id}/`)
  },
}
